import React from 'react'
import { Popover, useTheme } from '@mui/material'
import { GlobalSearch } from 'iconsax-react'

// import FieldMenu from './FieldMenu'
import SimpleFieldDropdown, {
  SimpleFieldDropdownProps
} from './SimpleFieldDropdown'
import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from './styles'

const FieldFilters: React.FC<SimpleFieldDropdownProps> = ({ ...props }) => {
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = React.useState<SVGElement>(null)

  const classes = useStyles()

  const handleClick = React.useCallback(
    (event: React.MouseEvent<SVGElement, MouseEvent>) => {
      setAnchorEl(event.currentTarget)
    },
    []
  )

  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <>
      <Tooltip title='Custom Fields' arrow>
        <div className={classes.root}>
          <GlobalSearch
            className={classes.icon}
            size={theme.size.base}
            onClick={handleClick}
          />
        </div>
      </Tooltip>

      {anchorEl && (
        <Popover
          open
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
        >
          {/* <FieldMenu /> */}
          <SimpleFieldDropdown {...props} />
        </Popover>
      )}
    </>
  )
}

export default FieldFilters
